<template>
  <Dialog :title="title" width="900px" top="8vh" :modal="true" :visible.sync="status">
    <div class="vfWrap">
      <CreateClass ref="clsRef" @onSuccess="onSuccess" />
    </div>
  </Dialog>
</template>

<script>
import { Dialog } from "element-ui";
import CreateClass from "./createClass.vue";
export default {
  components: {
    Dialog,
    CreateClass
  },
  data() {
    return {
      status: false,
      title: '创建班级'
    }
  },
  methods: {
    openClassInfo(id) {
      this.title = id ? '班级设置' : '创建班级'
      this.status = true;
      this.$nextTick(() => {
        this.$refs.clsRef.loadClassDetail(id);
      })
    },
    onSuccess() {
      this.status = false;
      this.$emit('toRefresh')
    }
  }
}
</script>


<style lang="less" scoped>
// @import '~styles/book/detail.less';


</style>